import { toZonedTime } from './zoned-time';

type EventBoundary = { dateTime?: string | null; date?: string | null };

type ZonedEvent = {
  start: EventBoundary;
  end: EventBoundary;
};

// All-day boundaries are already floating dates — only a timed boundary carries an instant to move.
const toZonedBoundary = <B extends EventBoundary>(
  boundary: B,
  timeZone: string,
): B => {
  if (!boundary.dateTime) {
    return boundary;
  }
  const instant = new Date(boundary.dateTime);
  // toISOString throws on an invalid date where every other Date call only yields NaN.
  if (Number.isNaN(instant.getTime())) {
    return boundary;
  }
  return {
    ...boundary,
    dateTime: toZonedTime(instant, timeZone).toISOString(),
  };
};

export const toZonedEventTimes = <T extends ZonedEvent>(
  event: T,
  timeZone: string,
): T => ({
  ...event,
  start: toZonedBoundary(event.start, timeZone),
  end: toZonedBoundary(event.end, timeZone),
});
